<template>
  <div>
    <div class="ls_drawer_main_content">

      <div class="d-flex align-center justify-between">
        <h1 class="item_detail_header mb-15">
          {{ detail.name }}
          <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
          <!--<Tag v-show="detail.default" color="green">По-умолчанию</Tag>-->
        </h1>


        <Tooltip content="Изменить токен" placement="top">
          <Button type="info" class="cursor-pointer action-button"  @click="modal_2 = true">
            <img src="/static/svg/change_token.svg" alt="">
          </Button>
        </Tooltip>

      </div>


      <div class="fs-15 color-grey mb-30">
        <!-- CREATED DATE -->
        <Row class="mb-15">
          <Col span="12">
            Дата создания:
          </Col>
          <Col span="12">
            {{ formatDateTime(detail.created_date) }}
          </Col>
        </Row>

        <!-- STORE -->
        <Row>
          <Col span="12">
            Магазин:
          </Col>
          <Col span="12">
            <router-link
              :to="{ name: 'store_detail', params: { id: detail.store } }"
            >{{ detail.store_display }}
            </router-link
            >
          </Col>
        </Row>

        <!-- manufacturer_number -->
        <Row>
          <Col span="12">
            Заводской номер:
          </Col>
          <Col span="12">
            {{ detail.manufacturer_number}}
          </Col>
        </Row>

        <!-- expiration_date -->
        <Row>
          <Col span="12">
            Дата окончания тарифа:
          </Col>
          <Col span="12" v-if="detail.expiration_date != null">
            {{ formatDateTime(detail.expiration_date)}}
          </Col>
          <Col v-else span="12">
            -
          </Col>
        </Row>

        <!-- ofd_server_display -->
        <Row>
          <Col span="12">
            ОФД:
          </Col>
          <Col span="12" v-if="detail.ofd_server_display != '' ">
            {{ detail.ofd_server_display}}
          </Col>
          <Col v-else span="12">
            -
          </Col>
        </Row>

        <!-- ofd_status_display -->
        <Row class="mb-15">
          <Col span="12">
            Статус кассы:
          </Col>
          <Col span="12">
            {{ detail.ofd_status_display }}
          </Col>
        </Row>

        <!-- receipt_lang_display -->
        <Row class="mb-15">
          <Col span="12">
            Язык в фискальном чеке:
          </Col>
          <Col span="12">
            {{ detail.receipt_lang_display }}
          </Col>
        </Row>

        <!-- BALANCE -->
        <Row>
          <Col span="12">
            Наличные в кассе:
          </Col>
          <Col span="12">
            {{ formatNumber(detail.balance) }} {{ currency }}
          </Col>
        </Row>
      </div>

      <!--      &lt;!&ndash; RECENT SHIFT &ndash;&gt;-->
      <!--      <Row>-->
      <!--        <Col span="12">-->
      <!--          Последняя смена:-->
      <!--        </Col>-->
      <!--        <Col span="12">-->
      <!--          <router-link-->
      <!--            :to="{ name: 'shift_detail', params: { id: detail.last_shift.id } }"-->
      <!--          >{{ detail.last_shift.number }}</router-link-->
      <!--          >-->
      <!--        </Col>-->
      <!--      </Row>-->
      <Divider><h2>Последняя смена</h2></Divider>
      <Table
        :columns="last_shift_columns"
        :data="last_shift_data"
        style="margin-bottom: 40px;"
      ></Table>
      <!--      &lt;!&ndash; CASHIERS &ndash;&gt;-->
      <!--      <Row>-->
      <!--        <Col span="12">-->
      <!--          Кассиры:-->
      <!--        </Col>-->
      <!--        <Col span="12">-->
      <!--          {{ cashiers }}-->
      <!--        </Col>-->
      <!--      </Row>-->

      <Divider><h2>Последние документы</h2></Divider>

      <recentMoneyOrders
        style="min-height: 20%; margin-top: 20px"
        filter_by="cash"
        :filter_by_id="id"
      ></recentMoneyOrders>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()"
      >
        <Icon type="md-create"/>
      </Button
      >
<!--      <Button-->
<!--        v-if="display_delete_button"-->
<!--        type="error"-->
<!--        @click="checkCash()"-->
<!--        style="float: left"-->
<!--      >-->
<!--        <Icon type="md-trash"/>-->
<!--      </Button-->
<!--      >-->
    </div>
    <Spin size="large" fix v-if="loading"></Spin>




    <!--Modal for edit token-->
    <Modal
      :footer-hide="footerHide"
      v-model="modal_2"
      title="">

      <h3 class="mb-40">Изменение токена для кассы " {{detail.name}}"</h3>

      <div class="mb-40">
        <Label>Токен для отправки данных в ОФД</Label>
        <Input
          placeholder="Введите значение"
          v-model="new_token">
        </Input>
      </div>

      <Row type="flex" justify="center">
        <Button :disabled="!new_token" type="info" style="margin-right: 12px"
                @click="modal_3 = true">
          Сохранить
        </Button>
        <Button type="error" @click="modal_2 = false">Отмена</Button>
      </Row>
    </Modal>


    <!--Modal for check token-->
    <Modal
      :footer-hide="footerHide"
      v-model="modal_3"
      title="">

      <h3 class="mb-40">Вы действительно хотите изменить токен?</h3>

      <Row type="flex" justify="center">
        <Button type="info" style="margin-right: 12px"
                @click="changeToken(detail.id)">
          Да
        </Button>
        <Button type="error" @click="cancelToken()">Нет</Button>
      </Row>
    </Modal>


    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данную кассу?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction(detail.name)">
          Удалить
        </Button>
      </Row>
    </Modal>


  </div>
</template>

<script>

    import { base_url } from "../../http.js";
    import {BaseDetailData} from "../../base/base_detail.js";
    import recentMoneyOrders from "../../components/core/recentMoneyOrders";

    let _app = BaseDetailData();
    _app.components = {
        recentMoneyOrders
    };
    _app.data = function () {
        return {
            loading: true,
            detail: {},

            //  Additional nested data
            sections: [],
            showAddSectionModal: false,
            formSectionData: {
                name: ""
            },

            modal_2: false,
            modal_3: false,
            footerHide: true,
            new_token: '',

            removeModal: false,
            removeId: null
        };
    };
    _app.computed.last_shift_columns = function () {
        return [
            {
                title: "Номер смены",
                align: "center",
                render: (h, params) => {
                    return h(
                        "router-link",
                        {
                            props: {
                                to: {
                                    name: "shift_detail",
                                    params: {id: params.row.id}
                                }
                            }
                        },
                        params.row.number
                    );
                }
            },
            {
                title: "Дата открытия",
                align: "center",
                render: (h, params) => {
                    return h(
                        "div",
                        {},
                        this.formatDateTime(params.row.open_date)
                    );
                }
            },
            {
                title: "Дата закрытия",
                align: "center",
                render: (h, params) => {
                    return h(
                        "div",
                        {},
                        this.formatDateTime(params.row.close_date)
                    );
                }
            }
        ];
    };
    _app.computed.last_shift_data = function () {
        if (this.detail.last_shift) {
            return [
                {
                    id: this.detail.last_shift.id,
                    number: this.detail.last_shift.number,
                    open_date: this.detail.last_shift.open_date,
                    close_date: this.detail.last_shift.close_date,
                }
            ];
        } else {
            return [];
        }
    };
    // _app.computed.recent_operations_mode = function() {
    //   return "Движение денег";
    // };
    _app.computed.cashiers = function () {
        // return this.detail.cashiers_display.join(', ')
        // return 'fff'
        if ("cashiers_display" in this.detail) {
            return this.detail.cashiers_display.join(", ");
        } else {
            return "";
        }
    };
    _app.methods.editAction = function () {

        const url = base_url + '/cashes/' + this.detail.id + '/current_shift/';
        this.$http
            .get(url)
            .then(response => {
                this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Для редактирования данных по кассе необходимо закрыть смену'
                });
            })
            .finally(() => {
            })
            .catch(error => {
                this.$router.push({
                    name: this.item_type + "_edit",
                    params: {id: this.id}
                });

            })


    };

    _app.methods.checkCash = function () {
        const url = base_url + '/cashes/' + this.detail.id + '/current_shift/';
        this.$http
            .get(url)
            .then(response => {
                this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Для удаления кассы необходимо закрыть смену'
                });
            })
            .finally(() => {
            })
            .catch(error => {
                this.removeModal = true;

            })
    };

    _app.methods.changeToken = function (id) {
        const url = base_url + '/cashes/' + id + '/token/';
        this.$http
            .put(url, {
                'token': this.new_token
            })
            .then(response => {
                this.$Notice.open({
                    title: 'Уведомление',
                    desc: 'Токен успешно изменен!'
                });

            })
            .finally(() => {
                this.cancelToken();
            })
            .catch(error => {
                this.$Notice.open({
                    title: 'Ошибка',
                    desc: 'Произошла ошибка. Обратитесь в службу поддержки.'
                });

            })
    };

    _app.methods.cancelToken = function () {
        this.modal_2 = false;
        this.modal_3 = false;
        this.new_token = null
    };


    export default _app;
</script>

<style scoped>
  button.action-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    margin: 0 6px;
  }
</style>

<style>
  button.action-button span {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/apps/cash/cashDetail.vue